import { Smartphone, Cpu, CreditCard } from "lucide-react";

const SERVICES = [
  {
    icon: Smartphone,
    image:
      "https://images.pexels.com/photos/16229745/pexels-photo-16229745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Smartphone displaying modern mobile UX with motion graphics",
    title: "Mobile Applications",
    copy: "Consumer-focused applications built with modern touch interfaces and low-latency client performance.",
    tags: ["iOS & Android", "Native UI"],
    testId: "service-card-mobile",
  },
  {
    icon: Cpu,
    image:
      "https://images.pexels.com/photos/17483870/pexels-photo-17483870.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Data flow diagram representing machine learning model connections",
    title: "AI-Powered Features",
    copy: "Integration of intelligent features, dynamic generation tools, and predictive algorithmic modules.",
    tags: ["AI Pipelines", "Real-time"],
    testId: "service-card-ai",
  },
  {
    icon: CreditCard,
    image:
      "https://images.unsplash.com/photo-1740150884358-5a254d7ae5de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwY2hlY2tvdXQlMjBzY3JlZW58ZW58MHx8fHwxNzkyMzExNzMwfDA&ixlib=rb-4.1.0&q=85",
    alt: "Digital checkout screen with secure credit card and token badge",
    title: "Digital Subscriptions",
    copy: "Turnkey recurring membership pipelines, secure payment integration, and access entitlements.",
    tags: ["Payment Rails", "Stripe Ready"],
    testId: "service-card-subscriptions",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 px-6 max-w-6xl mx-auto" data-testid="services-section">
      <div className="mb-14">
        <span className="text-xs uppercase font-bold tracking-widest text-emerald-700 kaje-body">
          Product Domains
        </span>
        <h2 className="text-3xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-1">
          Specialised Development Offerings
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SERVICES.map((s) => {
          const Icon = s.icon;
          return (
            <div
              key={s.title}
              data-testid={s.testId}
              className="bg-white p-6 rounded-lg border border-slate-200 shadow-sm flex flex-col justify-between transition-shadow duration-300 hover:shadow-lg"
            >
              <div className="aspect-video rounded overflow-hidden mb-6 relative bg-slate-900">
                <img
                  src={s.image}
                  alt={s.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover kaje-drift"
                />
                <div className="absolute bottom-2 right-2 w-9 h-9 rounded bg-slate-950/70 backdrop-blur flex items-center justify-center text-emerald-400">
                  <Icon className="w-5 h-5" strokeWidth={1.5} />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900">{s.title}</h3>
                <p className="kaje-body text-sm text-slate-600 mt-2 leading-relaxed">{s.copy}</p>
              </div>
              <div className="mt-6 pt-4 border-t border-slate-100 kaje-body text-xs font-semibold text-emerald-700 flex justify-between">
                <span>{s.tags[0]}</span>
                <span>{s.tags[1]}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
